import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import {
  MarkSeenInput,
  MarkSeenOutput,
  WebAppRoutes,
} from "types/web-app";

export const markSeen = async (
  accessToken: string,
  input: MarkSeenInput,
) => {
  try {
    const response = await fetchWithAuth(
      "/" + WebAppRoutes.MARK_SEEN,
      accessToken,
      {
        method: "POST",
        body: JSON.stringify(input),
      },
    );

    return (await response.json()) as ServiceResponse<MarkSeenOutput>;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
